import { useMemo } from 'preact/hooks';

const getSelectOptions = (lineItemQuantity: number) => {
  return Array.from({ length: lineItemQuantity }, (_, index) => {
    const returnQuantity = index + 1;
    return {
      label: returnQuantity.toString(),
      value: returnQuantity,
    };
  });
};

export const useQuantityInput = (lineItemQuantity: number) => {
  const selectOptions = useMemo(
    () => getSelectOptions(lineItemQuantity),
    [lineItemQuantity],
  );

  return {
    selectOptions,
  };
};
